import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { ChevronRight } from 'lucide-react';
import { NAVBAR_MENU_KEYS, NS } from '../../../../i18n/constants/keys';
import { SettingsIcon } from '../../../../icons/animated';

export const SystemSettingsHeader = () => {
  const { t } = useTranslation(NS.navbarMenus);

  return (
    <Box sx={{ mb: 1 }}>
      {/* Top Breadcrumb row */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1.5,
          py: 1,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography
            variant="caption"
            sx={{ color: 'text.secondary', fontSize: '0.75rem', fontWeight: 500 }}
          >
            Administration
          </Typography>
          <ChevronRight size={14} color="#94a3b8" />
          <Typography
            variant="caption"
            sx={{ fontWeight: 600, color: 'primary.main', fontSize: '0.75rem' }}
          >
            {t(NAVBAR_MENU_KEYS.systemSettings.title)}
          </Typography>
        </Stack>

        <Chip
          label={t(NAVBAR_MENU_KEYS.systemSettings.online)}
          size="small"
          color="success"
          variant="outlined"
          sx={{ fontWeight: 600, fontSize: '0.75rem', height: 24 }}
        />
      </Box>

      {/* Main Title Banner */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pt: 2,
          pb: 0.5,
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: 2.5,
              background: 'linear-gradient(135deg, #093725, #047857)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(9, 55, 37, 0.2)',
              flexShrink: 0,
            }}
          >
            <SettingsIcon size={24} color="#ffffff" />
          </Box>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, color: 'text.primary', letterSpacing: '-0.02em' }}>
              {t(NAVBAR_MENU_KEYS.systemSettings.title)}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
              {t(NAVBAR_MENU_KEYS.systemSettings.description)}
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};
